import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { DesyAngularModule } from 'desy-angular';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DropdownOption } from '@/app/interfaces/filtersAdvanced';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
@Component({
  selector: 'app-dropdown',
  imports: [CommonModule, DesyAngularModule, ReactiveFormsModule, FormsModule],
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownComponent),
      multi: true,
    },
  ],
})
export class DropdownComponent implements ControlValueAccessor {
  @Output() select = new EventEmitter<string>();

  @Input() label: string = '';
  @Input() options: DropdownOption[] = [];
  @Input() disabled = false;
  @Input() id: string = '';
  @Input() role: string = 'button';
  @Input() classesTooltip: string = '';
  @Input() classesContainer: string = '';
  @Input() routerLink: string = '';
  @Input() icon: string = '';
  @Input() type: string = 'dropdown';
  @Input() classes: string = '';
  @Input() hiddenArrow: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() value: string = '';

  @Output() valueChange = new EventEmitter<string>();
  selected: string | null = null;
  private touched = false;
  onChange: (_) => void = () => {};
  onTouched: () => void = () => {};

  writeValue(value): void {
    this.selected = value;
  }

  registerOnChange(fn): void {
    this.onChange = fn;
  }

  registerOnTouched(fn): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelectValue(event: Event | string) {
    const valueSelected = event instanceof CustomEvent ? event.detail : event;

    // Solo hacemos algo si realmente hay un valor
    if (valueSelected !== null && valueSelected !== undefined && valueSelected !== '') {
      this.selected = valueSelected;
      this.select.emit(valueSelected);
      this.onChange(valueSelected);

      // Solo marcamos touched una vez
      if (!this.touched) {
        this.onTouched();
        this.touched = true;
      }
    }
  }

  getSelectedLabel(): string {
    const option = this.options.find((o) => o.value === this.selected);
    return option ? option.label : this.label;
  }
}
